module.exports = __webpack_public_path__ + "static/img/Logo.ce97191.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/Logo.png
// module id = iOxY
// module chunks = 0